import {inject, Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {environment} from 'src/environments/environment';
import {HttpClient} from '@angular/common/http';
import {BrandRequest} from '../models/requests/brand.request';
import {BrandThemeResponse} from '../models/requests/brand-theme.response';

@Injectable({providedIn: 'root'})

export class ThemeService {
  private readonly _httpClient: HttpClient = inject(HttpClient);

  public getTheme(branding: BrandRequest): Observable<BrandThemeResponse> {
    const requestUrl = environment.apiUrl + environment.treatmentApi + `navigation/get-branding`;
    return this._httpClient.post<BrandThemeResponse>(requestUrl, branding);
  }
}
